module.exports = __webpack_public_path__ + "img/let-it-snow-tiles-2-thumb.jpg";